(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["last-units"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('last-units')) {
    class LastUnits extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        this.section?.addEventListener('variant:update', this.update);
      }

      disconnectedCallback() {
        this.section?.removeEventListener('variant:update', this.update);
      }

      update = (event) => {
        const data = event.detail?.data;
        if (!data?.html) return;

        if (data.newProduct) {
          this.dataset.productId = data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
          return;
        }

        const fresh = data.html.querySelector(`last-units[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh) return;

        this.innerHTML = fresh.innerHTML;
        this.hidden = fresh.hidden;
      };
    }

    customElements.define('last-units', LastUnits);
  }
  } catch(e) { console.error(e); }
})();

})();
